import { TSong } from '@/context/global/types/song';

/**
 * เช็คว่ามีเพลงที่ถูก lock หรือไม่
 * true เมื่อ: เพลงทั้งหมด lock หรือ เพลงแรก lock
 * conditions == 2 (silver song) && badge == 3 (silver user)
 */
export const hasLockedSong = (
  songs: TSong[] | undefined | null,
  badge: number | undefined,
): boolean => {
  if (!songs?.length) return false;
  const isLocked = (song: TSong) => song.conditions == 2 && badge == 3;
  return songs.every(isLocked) || isLocked(songs[0]);
};
